// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1-1BD","buttons":"RemoveExpirationActionButtons_buttons__3USHr"};